import { Button, Dialog, DialogContent, DialogTitle, Divider, Stack, Typography } from "@mui/material";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import InlineItemsList from "@entrilia/shared/components/InlineItemsList";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { InvestorCommunicationFund } from "../../../../../api/types/investorCommunicationsTypes";
import InvestorCommunicationRecipientsList from "../../InvestorCommunicationRecipientsList";
import InvestorCommunicationContext from "../InvestorCommunicationContext";

const maxDisplayedFunds = 3;

interface Props {
  onClose: () => void;
}

const InvestorCommunicationRecipientsPreviewDialog = ({ onClose }: Props) => {
  const { investorCommunication, recipients, readersByContactId } = useDefinedContext(
    InvestorCommunicationContext,
    "InvestorCommunicationContext"
  );

  return (
    <Dialog open fullWidth maxWidth="lg" onClose={onClose}>
      <DialogTitle>Recipients preview</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <Divider />
      <DialogContent sx={{ display: "flex", flexDirection: "column", height: "60vh" }}>
        <Stack spacing={2} sx={{ flex: 1, minHeight: 0 }}>
          <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
            <Typography color="textSecondary">Funds:</Typography>
            <InlineItemsList<InvestorCommunicationFund>
              items={investorCommunication.funds}
              displayCount={maxDisplayedFunds}
              propGetter={(fund) => fund.name}
              popupTitle="Funds"
            />
          </Stack>
          <InvestorCommunicationRecipientsList
            type={investorCommunication.type}
            recipients={recipients}
            readersByContactId={readersByContactId}
          />
        </Stack>
      </DialogContent>
      <Divider />
      <DialogButtons>
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogButtons>
    </Dialog>
  );
};

export default InvestorCommunicationRecipientsPreviewDialog;
